module.exports = __webpack_public_path__ + "static/media/andI.39a276de.jpg";